import {
  getDatetime,
  getSourceUrl,
  getThingAll,
  saveSolidDatasetAt,
  removeThing,
} from "@inrupt/solid-client";
import { useSession } from "@inrupt/solid-ui-react";
import { Table, TableColumn } from "@inrupt/solid-ui-react";
import React from "react";

import DeleteQuoteButton from "./DeleteQuoteButton";

import { TEXT_PREDICATE, CREATED_PREDICATE } from "../../lib/predicates";

// TODO: add a checked option for displaying in three playground?  Or limit this to public/private/personal lists?

function QuoteList({ quoteList, setQuoteList, listOwner }) {
  const { session } = useSession();

  // quoteList && console.log(quoteList);

  const quoteThings = quoteList ? getThingAll(quoteList) : [];
  // newest quotes first
  quoteThings.sort((a, b) => {
    return (
      getDatetime(b, CREATED_PREDICATE) - getDatetime(a, CREATED_PREDICATE)
    );
  });
  // if (quoteThings) console.log(quoteThings);

  const thingsArray = quoteThings.map((t) => {
    return { dataset: quoteList, thing: t };
  });

  if (!thingsArray.length) return null;

  const deleteQuote = async (quote) => {
    const quotesUrl = getSourceUrl(quoteList);
    const updatedQuotes = removeThing(quoteList, quote);
    const updatedDataset = await saveSolidDatasetAt(quotesUrl, updatedQuotes, {
      fetch: session.fetch,
    });
    setQuoteList(updatedDataset);
  };

  return (
    <div className="table-container">
      <h3>{listOwner.replace(/.*\/([^\/]+)$/, "$1")} List</h3>
      <span className="tasks-message">
        Your list has {quoteThings.length} items
      </span>
      <Table className="table" things={thingsArray}>
        <TableColumn property={TEXT_PREDICATE} header="Quote" />
        <TableColumn
          property={CREATED_PREDICATE}
          dataType="datetime"
          header="Created At"
          body={({ value }) => value.toDateString()}
        />
        <TableColumn
          property={TEXT_PREDICATE}
          header="Remove"
          body={() => <DeleteQuoteButton deleteQuote={deleteQuote} />}
        />
      </Table>
    </div>
  );
}

export default QuoteList;
